
import { Currency } from '../Batch/Currency'
import { Percentage } from './Percentage'
import { NewDate } from '../News/NewDate'

export class DanosMadeirables {
  private _importeSenIve: Currency |null
  private _iva: Percentage |null
  private _importeIve: Currency |null
  private _importeTotal: Currency |null
  private _dataNotAdxudicacion: NewDate |null
  private _dataPagamentoDanos: NewDate |null

  constructor (
    importeSenIve: Currency |null,
    iva: Percentage |null,
    importeIve: Currency |null,
    importeTotal: Currency |null,
    dataNotAdxudicacion: NewDate |null,
    dataPagamentoDanos: NewDate |null

  ) {
    this._importeSenIve = importeSenIve
    this._iva = iva
    this._importeIve = importeIve
    this._importeTotal = importeTotal
    this._dataNotAdxudicacion = dataNotAdxudicacion
    this._dataPagamentoDanos = dataPagamentoDanos
  }

  get importeSenIve (): Currency {
    if (this._importeSenIve !== null) {
      return this._importeSenIve
    } else { return new Currency(0) }
  }

  get iva (): number {
    if (this._iva !== null) {
      return this._iva.percentage()
    } else { return 0 }
  }

  get importeIve (): Currency {
    if (this._importeIve !== null) {
      return this._importeIve
    } else { return new Currency(0) }
  }

  get importeTotal (): Currency {
    if (this._importeTotal !== null) {
      return this._importeTotal
    } else { return new Currency(0) }
  }

  get dataNotAdxudicacion (): string {
    if (this._dataNotAdxudicacion !== null) {
      return this._dataNotAdxudicacion.date()
    } else { return '' }
  }

  get dataPagamentoDanos (): string {
    if (this._dataPagamentoDanos !== null) {
      return this._dataPagamentoDanos.date()
    } else { return '' }
  }
}
